const HISTORY_KEY = "videoHistoryIndex";
const HISTORY_LIMIT = 200;
const LS_KEY = (s) => `videoProgress:${s}`;

export function loadProgress(slug) {
  try { const raw = localStorage.getItem(LS_KEY(slug)); return raw ? JSON.parse(raw) : null; } catch { return null; }
}
export function saveProgress(slug, seconds, duration) {
  try {
    const payload = {
      seconds: Math.max(0, Math.floor(seconds || 0)),
      duration: Math.max(0, Math.floor(duration || 0)),
      updatedAt: Date.now(),
    };
    localStorage.setItem(LS_KEY(slug), JSON.stringify(payload));
  } catch {}
}

export function loadHistoryIndex() {
  try { const raw = localStorage.getItem(HISTORY_KEY); const arr = raw ? JSON.parse(raw) : []; return Array.isArray(arr) ? arr : []; } catch { return []; }
}
export function saveHistoryIndex(arr) {
  try { localStorage.setItem(HISTORY_KEY, JSON.stringify(arr.slice(0, HISTORY_LIMIT))); } catch {}
}